import { useRef, useEffect } from 'react';
import ImageArcGISRestSource from 'ol/source/ImageArcGISRest';
import OLImageLayer from 'ol/layer/Image';
import { getAbsoluteUrl } from '@tmapy/utils';
import { useOLMap } from '../MapContext';
import { useLayerEffect } from './useLayerEffect';
import { getCrossOriginValue } from './getCrossOriginValue';
export const ImageArcGISRestLayer = (props) => {
    const map = useOLMap();
    const layerRef = useRef();
    useLayerEffect(layerRef, props.layerOptions);
    useEffect(() => {
        const projection = map.getView().getProjection();
        const sourceParams = {
            ...props.sourceOptions,
            projection,
            crossOrigin: getCrossOriginValue(props.sourceOptions.url),
            wrapX: projection.isGlobal(),
            imageLoadFunction: (image, src) => {
                const url = getAbsoluteUrl(src) ?? '';
                src = url.toString();
                image.getImage().src = src;
            },
        };
        const layer = new OLImageLayer({
            source: new ImageArcGISRestSource(sourceParams),
            visible: props.layerOptions.visible,
            opacity: props.layerOptions.opacity ?? 1,
            minResolution: props.layerOptions.minResolution,
            maxResolution: props.layerOptions.maxResolution,
            zIndex: props.layerOptions.zIndex,
        });
        layerRef.current = layer;
        map.addLayer(layer);
        if (process.env.NODE_ENV === 'development') {
            console.debug('new ImageArcGISRestLayer', map, layerRef.current);
        }
        return () => {
            // unmount
            const layer = layerRef.current;
            if (layer) {
                map.removeLayer(layer);
                layer.dispose();
                layerRef.current = null;
            }
        };
    }, [map, props.sourceOptions]);
    return null;
};
//# sourceMappingURL=ImageArcGISRestLayer.js.map